import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { ContentTextTo3d } from './ContentTextTo3d';

export type ContentTextTo3dContainerProps = {};

const LOCALSTORAGE_KEY = 'TEXT_TO_3D_TARGET';

const targetMap: any = {
  'Low Poly': 'lowpoly',
  '3D Print': '3dprint',
  Standard: 'standard',
};

export function ContentTextTo3dContainer(_props: ContentTextTo3dContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const credits = useSelector(selectors.base.$credits);
  const user = useSelector(selectors.base.$user);
  const { tsStartExternal, externalGlb } = appState;
  const [source, setSource] = useState('sample');
  const [lastPrompt, setLastPrompt] = useState('');
  const [target, setTarget] = useLocalStorage(LOCALSTORAGE_KEY, 'Standard');

  const { isEmployee } = user;

  const callbacks = useMemo(
    () => ({
      onGenerate: (prompt: string) => {
        setLastPrompt(prompt);

        dispatch({
          type: 'TEXT-TO-3D',
          verb: 'generate',
          payload: {
            prompt,
            target: targetMap[target ?? ''],
          },
        });

        setSource(source);
      },
      onDownload: (externalGlb: string) => {
        dispatch({
          type: 'TEXT-TO-3D',
          verb: 'download',
          payload: {
            externalGlb,
            source,
          },
        });
      },
      onChangeTarget: (value: string) => {
        setTarget(value);
      },
    }),
    [target]
  );

  return (
    <ContentTextTo3d
      isEmployee={isEmployee}
      credits={credits}
      target={target}
      lastPrompt={lastPrompt}
      externalGlb={externalGlb}
      tsStart={tsStartExternal}
      callbacks={callbacks}
    />
  );
}

export default ContentTextTo3dContainer;
